const checkValidAudioFile = (audioString) => {
    let isValid = false

    if (audioString.includes('.mp3') || audioString.includes('.wav') || audioString.includes('.ogg')) isValid = true

    return isValid
}

export default checkValidAudioFile